// Função para gerar template CSV de Status (Entidades)
export const generateStatusTemplate = (): string => {
  const headers = ['Nome', 'Setor', 'Ficha de Inscrição', 'Formulário', 'Logo', 'Observações', 'Instagram'];
  
  const exampleRows = [
    ['Região: Sul', '', '', '', '', '', ''],
    ['São Paulo', '', '', '', '', '', ''],
    ['Restaurante Exemplo 1', 'Fast Food', 'OK', 'OK', 'OK', 'Exemplo de observação', '@exemplo1'],
    ['Restaurante Exemplo 2', 'Varejo', 'OK', '', '', '', '@exemplo2'],
    ['Restaurante Exemplo 3', '', '', '', '', 'Aguardando documentação', ''],
    ['', '', '', '', '', '', ''],
    ['Rio de Janeiro', '', '', '', '', '', ''],
    ['Restaurante Exemplo 4', 'Alimentação', 'OK', 'OK', 'OK', '', '@exemplo4'],
  ];

  const rows = [headers, ...exampleRows];
  return rows.map(row => row.join(',')).join('\n');
};

// Função para gerar template CSV de Contatos (formato internacional)
export const generateContactsTemplate = (): string => {
  const headers = [
    'email',
    'first_name',
    'last_name',
    'company',
    'position',
    'cell_phone',
    'phone',
    'website',
    'city',
    'state_province_region',
    'postal_code',
    'country',
    'address_line_1',
    'address_line_2',
    'external_id',
    'anonymous_id'
  ];
  
  const exampleRows = [
    [
      'joao@exemplo.com',
      'João',
      'Silva',
      'Restaurante Exemplo',
      'Gerente',
      '+55 11 98765-4321',
      '+55 11 3456-7890',
      'www.exemplo.com',
      'São Paulo',
      'SP',
      '01310-100',
      'Brasil',
      'Rua Exemplo, 123',
      'Sala 45',
      'EXT001',
      'ANON001'
    ],
    [
      'maria@exemplo.com',
      'Maria',
      'Santos',
      'Operadora ABC',
      'Diretora',
      '+55 21 99876-5432',
      '',
      'www.operadora.com',
      'Rio de Janeiro',
      'RJ',
      '20040-020',
      'Brasil',
      'Avenida Exemplo, 456',
      '',
      'EXT002',
      ''
    ]
  ];

  const rows = [headers, ...exampleRows];
  return rows.map(row => row.map(cell => `"${cell}"`).join(',')).join('\n');
};

// Função para fazer download do template
export const downloadTemplate = (content: string, filename: string): void => {
  const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
  window.URL.revokeObjectURL(url);
};
